import { Component } from '@angular/core';
import {  NavController, NavParams, MenuController } from 'ionic-angular';
import { BuscadorPage } from '../buscador/buscador';

/**
 * Generated class for the ContactoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-quienes-somos',
  templateUrl: 'quienes-somos.html',
})
export class QuieneSomosPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,public menuCtrl:MenuController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad QuieneSomosPage');
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/quienes-somos/quienes-somos.ts